module.exports = __webpack_public_path__ + "media/images/guideline/A01-e30ddfbc282199bb56cb8be9828de35a.jpg";